export const account = state => state.userInfo
export const project = state => state.project
export const el = state => state.el
export const app = state => state.app
export const transfer = state => state.transfer
export const clearKeep = state => state.clearKeep
export const notice = state => state.notice
export const scroll = state => state.scroll
export const size = state => state.size

//
export const user = state => state.user
export const space = state => state.space
export const permissions = state => state.permissions
export const show = state => state.show
export const updateEl = state => state.updateEl
